import React, { useState } from 'react'

import { useMediaQuery } from 'react-responsive'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { landingPageUrl } from 'src/Constants/links'
import CloseIconWhite from 'src/Assets/Svg/closeWhite.svg?react'
import CloseIconGreen from 'src/Assets/Svg/closeGreen.svg?react'
import { getAuthType } from 'src/Redux/auth-process/authTypeSlice/selectors'
import { MAX_MOBILE_WIDTH, device } from 'src/Styled/variables'
import { RoleSelect } from 'src/Components/RoleSelect'
import { Roles } from 'src/Constants/enums'
import { APP } from 'src/Configs/App'
import { initiateSpotifyAuth } from 'src/Utils/spotifyAuth'
import { PublicRoutesEnum } from 'src/Router/PublicComponentsNewUI'

import { MAP_LOGIN_FORM } from './helpers'
import { useLogin } from './useLogin'

const CloseButton = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  margin-left: auto;
  margin-right: 16px;
  margin-top: 16px;
  & svg {
    width: 20px;
    height: 20px;
  }

  @media (min-width: 768px) {
    position: absolute;
    width: 24px;
    height: 24px;
    top: 45.5px;
    right: 44.5px;
    & svg {
      width: 16px;
      height: 16px;
    }
  }
`

const Logo = styled.div`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: auto;
  }
`

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  width: 100%;
`

const Wrapper = styled.div`
  height: 100vh;
  background-color: ${({ theme }) => theme.unchangingColor.black};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    padding: 0 16px;
  }
`

const logo = '/logo.png'

const Card = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ $compact }) => ($compact ? '12px' : '24px')};
  width: 320px;
  min-width: 288px;
  padding: 32px;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  border-radius: 16px;
  box-shadow: 0 0 20px 0 rgba(52, 52, 52, 0.3);

  @media ${device.mobileMin} {
    width: 600px;
    min-width: 600px;
    max-width: 600px;
    padding: 48px;
  }
`

const LogIn: React.FC = () => {
  const { contextHolder } = useLogin()
  const navigate = useNavigate()

  const authType = useSelector(getAuthType)
  const [roleChosen, setRoleChosen] = useState(false)

  const onGoToLanding = (): void => {
    window.location.href = landingPageUrl
  }

  const onGoToSignUp = (): void => {
    navigate(PublicRoutesEnum.SignUpChooseRole)
  }

  const onSelectRole = (role: Roles): void => {
    if (role === Roles.artist) {
      setRoleChosen(true)
      return
    }

    if (role === Roles.curator) {
      initiateSpotifyAuth()
    } else {
      window.location.href = APP.TIKTOK_AUTH_API
    }
  }

  const isMobile = useMediaQuery({ maxWidth: 576 })
  return (
    <Wrapper>
      {contextHolder}
      <CloseButton data-testid='close-button' onClick={onGoToLanding}>
        {isMobile ? <CloseIconGreen /> : <CloseIconWhite />}
      </CloseButton>
      <LoginContainer>
        <Logo>
          <img width={236} height={52} alt='logo' src={logo} />
        </Logo>
        {roleChosen ? (
          <Card $compact={authType === 'withoutSignup'}>
            {MAP_LOGIN_FORM[authType] || null}
          </Card>
        ) : (
          <RoleSelect
            variant='login'
            onSelectRole={onSelectRole}
            onFooterAction={onGoToSignUp}
          />
        )}
      </LoginContainer>
    </Wrapper>
  )
}
export default LogIn
